<template>
  <div>
    <v-main>
      <v-container fluid>
        <app-headline :title="title" />

        <v-row>
          <v-col>
            <v-card
              class="py-6"
              :class="{ 'px-12': $vuetify.breakpoint.smAndUp }"
            >
              <v-container>
                <v-stepper v-model="currentStep" vertical>
                  <v-stepper-step
                    :complete="currentStep > 1"
                    step="1"
                    :editable="validateStep1"
                  >
                    ข้อมูลส่วนบุคคล

                    <!-- <small>Summarize if needed</small> -->
                  </v-stepper-step>

                  <v-stepper-content step="1">
                    <div>
                      <div>
                        <v-row
                          v-for="(item, index) in info"
                          :key="index"
                          class="py-1"
                          align="center"
                        >
                          <v-col cols="12" sm="3" class="font-weight-bold">
                            {{ item.title }}
                          </v-col>

                          <v-col
                            :class="{ 'pt-0 pl-5': $vuetify.breakpoint.xsOnly }"
                          >
                            <span>
                              {{ item.value || $t('noData') }}
                            </span>

                            <v-btn
                              v-if="item.edit"
                              class="mx-1"
                              color="primary darken-2"
                              icon
                              @click="onEdit(item.id)"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </v-col>

                          <v-col v-if="item.id === 'addresss'" cols="12">
                            <div class="grey--text">
                              *ที่อยู่ใช้ในการออกใบเสร็จรับเงิน
                            </div>
                          </v-col>
                        </v-row>
                      </div>

                      <div class="grey--text py-2">
                        หากต้องการแก้ไขข้อมูลส่วนอื่นๆ สามารถเข้าไปแก้ไขได้ที่

                        <a
                          href="https://mis.cmu.ac.th/"
                          target="_blank"
                          rel="opener"
                        >
                          mis.cmu.ac.th
                        </a>

                        หรือแจ้งเจ้าหน้าที่บุคคลของส่วนงานของท่าน
                      </div>

                      <div v-if="!validateStep1" class="error--text py-2">
                        *ข้อมูลหมายเลขโทรศัพท์และที่อยู่เป็นข้อมูลที่จำเป็น
                        หากไม่มี กรุณากดที่ไอคอน

                        <v-icon>mdi-pencil</v-icon> เพื่อแก้ไข
                      </div>

                      <div class="text-center pt-4">
                        <v-btn
                          class="mx-1"
                          color="primary darken-2"
                          depresses
                          large
                          :disabled="!validateStep1"
                          @click="currentStep = 2"
                        >
                          ต่อไป
                        </v-btn>
                      </div>
                    </div>
                  </v-stepper-content>

                  <v-stepper-step
                    :complete="currentStep > 2"
                    step="2"
                    :editable="validateStep2"
                  >
                    เลือกประเภทบัตรที่ต้องการ
                  </v-stepper-step>

                  <v-stepper-content step="2">
                    <div>
                      <div class="ml-2">
                        <v-radio-group v-model="cardType">
                          <v-radio
                            v-for="(item, index) in cardTypeList"
                            :key="index"
                            :label="
                              !item.btnCheckReqCardType
                                ? item.text +
                                  ` (ประเภทบัตรนี้อยู่ในระหว่างการขอทำบัตร สามารถตรวจสอบได้ที่เมนู 'สถานะการขอทำบัตร')`
                                : item.text
                            "
                            :value="item.value"
                            :disabled="!item.btnCheckReqCardType"
                            @change="handlerFirstTime(item.btnFirstReqCard)"
                          />
                        </v-radio-group>
                      </div>

                      <div v-if="!validateStep2" class="error--text py-2">
                        *กรุณาเลือกประเภทบัตร
                      </div>

                      <div class="text-center pt-4">
                        <v-btn
                          class="mx-1"
                          color="secondary"
                          depresses
                          @click="currentStep = 1"
                        >
                          ย้อนกลับ
                        </v-btn>

                        <v-btn
                          class="mx-1"
                          color="primary darken-2"
                          depresses
                          large
                          :disabled="!validateStep2"
                          @click="currentStep = 3"
                        >
                          ต่อไป
                        </v-btn>
                      </div>
                    </div>
                  </v-stepper-content>

                  <v-stepper-step
                    :complete="currentStep > 3"
                    step="3"
                    :editable="validateStep3"
                  >
                    อัพโหลดรูปติดบัตร
                  </v-stepper-step>

                  <v-stepper-content step="3">
                    <v-card
                      v-if="profilePicture === ''"
                      color="grey lighten-1"
                      class="mb-4 pa-12 text-center"
                      height="252px"
                      outlined
                      @click="$refs.profilePicture.click()"
                    >
                      <div class="pa-4">
                        <v-icon size="60">mdi-file-image-outline</v-icon>
                      </div>

                      <div class="pa-4">
                        อัพโหลดภาพ
                      </div>
                    </v-card>

                    <v-card
                      v-if="profilePicture !== ''"
                      class="mb-4 pa-1 text-center"
                      height="252px"
                      outlined
                      @click="$refs.profilePicture.click()"
                    >
                      <img :src="profilePicture" height="240" />
                    </v-card>

                    <input
                      type="file"
                      ref="profilePicture"
                      accept=".jpg, .jpeg, .png"
                      hidden
                      @input="onSelectProfilePicture"
                    />

                    <div v-if="!validateStep3" class="error--text py-2">
                      *กรุณาเลือกไฟล์อัพโหลด
                    </div>

                    <div class="mb-4">
                      <div class="grey--text mb-1">
                        - รองรับเฉพาะไฟล์รูปภาพ .jpg, .jpeg, หรือ .png เท่านั้น
                      </div>

                      <div class="grey--text mb-1">
                        - บัตรประจำตัว ข้าราชการ พนักงานมหาวิทยาลัยประจำ
                        และลูกจ้างประจำ ต้องมีพื้นหลังเป็นสีม่วง
                      </div>

                      <div class="grey--text mb-1">
                        - บัตรประจำตัวพนักงานมหาวิทยาลัยประเภทชั่วคราว
                        ต้องมีพื้นหลังเป็นสีฟ้า
                      </div>

                      <div class="grey--text mb-1">
                        - หากไม่สามารถหารูปภาพที่มีพื้นหลังตามที่ระบุไว้ได้
                        ควรเป็นพื้นหลังสีขาวล้วน
                      </div>

                      <div class="grey--text mb-1">
                        - รูปถ่าย จะต้องเป็นรูปถ่ายหน้าตรงสวมชุดสุภาพ
                        หากเป็นเครื่องแบบข้าราชการหรือพนักงานให้ประดับเครื่องหมายต่างๆ
                        ให้ถูกต้อง ไม่สวมแว่นตาสีดำหรือสีเข้ม (ห้ามคอกลม แขนกุด)
                      </div>

                      <div class="grey--text mb-1">
                        - ขนาดรูปภาพไม่ต่ำกว่า 640 x 480 pixels ขนาดไม่เกิน 2 MB
                      </div>
                    </div>

                    <div class="text-center pt-4">
                      <v-btn
                        class="mx-1"
                        color="secondary"
                        depresses
                        @click="currentStep = 2"
                      >
                        ย้อนกลับ
                      </v-btn>

                      <v-btn
                        class="mx-1"
                        color="primary darken-2"
                        depresses
                        large
                        :disabled="!validateStep3"
                        @click="currentStep = 4"
                      >
                        ต่อไป
                      </v-btn>
                    </div>
                  </v-stepper-content>

                  <v-stepper-step step="4" :editable="validateStep4">
                    เหตุผลในการขอทำบัตร
                  </v-stepper-step>

                  <v-stepper-content step="4">
                    <div>
                      <div class="ml-2">
                        <v-radio-group v-model="reason" hide-details="auto">
                          <v-radio
                            v-for="(item, index) in reasonList"
                            :key="index"
                            :label="item.text + item.condition"
                            :value="item.value"
                            :disabled="item.disabled"
                          />
                        </v-radio-group>
                      </div>

                      <div v-if="!reason" class="error--text py-2">
                        *กรุณาเลือกเหตุผล
                      </div>

                      <div class="mt-4" v-if="reason > 2">
                        <v-textarea
                          v-model="reasonAddition"
                          label="เหตุผลเพิ่มเติม"
                          hide-details="auto"
                          outlined
                        />
                      </div>

                      <div
                        v-if="(reason === 6 || reason === 4) && !reasonAddition"
                        class="error--text py-2"
                      >
                        *กรุณาระบุเหตุผลเพิ่มเติม
                      </div>

                      <v-card v-if="reason > 0" class="pa-3 mt-4" outlined>
                        <span>แนบเอกสารเพิ่มเติม</span>

                        <div class="mb-4 mt-2">
                          <div class="grey--text mb-1">
                            - รองรับเฉพาะไฟล์ .jpg, .jpeg, .png, .doc, .docx,
                            หรือ .pdf เท่านั้น
                          </div>

                          <div class="grey--text mb-1">
                            - ขนาดไฟล์ไม่เกิน 5 MB
                          </div>
                        </div>

                        <div
                          v-if="
                            (reason === 2 || reason === 3 || reason === 5) &&
                              reasonFiles.length === 0 &&
                              oldreasonFiles.length === 0
                          "
                          class="error--text py-2"
                        >
                          *กรุณาแนบเอกสารอย่างน้อย 1 ไฟล์
                        </div>

                        <v-card
                          class="py-1 mt-1 my-2 mx-3 text-center"
                          outlined
                          @click="$refs.attachedDocument.click()"
                        >
                          <v-icon>mdi-plus</v-icon>

                          <span>เพิ่ม</span>
                        </v-card>

                        <input
                          type="file"
                          ref="attachedDocument"
                          accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
                          hidden
                          @change="onAddAttached"
                        />

                        <div
                          v-if="oldreasonFiles.length > 0 && isEdit"
                          class="px-4 pt-2"
                        >
                          <div
                            v-for="(file, index) in oldreasonFiles"
                            :key="index"
                          >
                            <v-card class="mb-2" outlined>
                              <div class="pa-2">
                                {{ file.reqCardDocName }}
                              </div>

                              <div class="text-right">
                                <v-btn
                                  class="mb-2 mr-2"
                                  color="error"
                                  x-small
                                  depressed
                                  @click="onOldReasonFileRemove(index)"
                                >
                                  <v-icon small>mdi-delete</v-icon> ลบ
                                </v-btn>
                              </div>
                            </v-card>
                          </div>
                        </div>

                        <div v-if="reasonFiles.length > 0" class="px-4 pb-2">
                          <div
                            v-for="(file, index) in reasonFiles"
                            :key="index"
                          >
                            <v-card class="mb-2" outlined>
                              <div class="pa-2">
                                {{ file.name }}
                              </div>

                              <div class="text-right">
                                <v-btn
                                  class="mb-2 mr-2"
                                  color="error"
                                  x-small
                                  depressed
                                  @click="onReasonFileRemove(index)"
                                >
                                  <v-icon small>mdi-delete</v-icon> ลบ
                                </v-btn>
                              </div>
                            </v-card>
                          </div>
                        </div>

                        <div
                          v-if="
                            reasonFiles.length <= 0 &&
                              oldreasonFiles.length <= 0
                          "
                        >
                          <div class="pa-2 text-center grey--text">
                            {{ $t('noData') }}
                          </div>
                        </div>
                      </v-card>
                    </div>

                    <div class="text-center pt-4">
                      <v-btn
                        class="mx-1"
                        color="secondary"
                        depresses
                        @click="currentStep = 3"
                      >
                        ย้อนกลับ
                      </v-btn>

                      <v-btn
                        :loading="loading"
                        class="mx-1"
                        color="success"
                        depresses
                        large
                        :disabled="!validateStep4"
                        @click="onSubmit"
                      >
                        ยืนยัน
                      </v-btn>
                    </div>
                  </v-stepper-content>
                </v-stepper>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-dialog v-model="dialog.mobilePhone" max-width="360" persistent>
      <v-card>
        <div class="pa-4 font-weight-bold">หมายเลขโทรศัพท์</div>

        <v-divider />

        <v-form
          ref="editMobilePhoneForm"
          @submit.prevent="onEditMobilePhoneSubmit"
        >
          <div class="pa-4">
            <v-text-field
              v-model="mobilePhone"
              :placeholder="แก้ไขหมายเลขโทรศัพท์"
              :rules="[rules.required, rules.onlyDigit]"
              :maxlength="10"
              outlined
              dense
              required
            />
          </div>

          <div class="text-center pb-4">
            <v-btn
              class="mx-1"
              color="primary darken-2"
              large
              depressed
              @click="onEditMobilePhoneSubmit"
            >
              บันทึก
            </v-btn>

            <v-btn
              class="mx-1"
              color="secondary"
              depressed
              @click="onEditMobilePhoneCancel"
            >
              ยกเลิก
            </v-btn>
          </div>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.addresss" max-width="360" persistent>
      <v-card>
        <div class="pa-4 font-weight-bold">ที่อยู่</div>

        <v-divider />

        <v-form ref="editAddressForm" @submit.prevent="onEditAddressSubmit">
          <div class="pa-4">
            <v-text-field
              v-model="addresss"
              :placeholder="แก้ไขที่อยู่"
              :rules="[rules.required]"
              outlined
              dense
              required
            />
          </div>

          <div class="text-center pb-4">
            <v-btn
              class="mx-1"
              color="primary darken-2"
              large
              depressed
              @click="onEditAddressSubmit"
            >
              บันทึก
            </v-btn>

            <v-btn
              class="mx-1"
              color="secondary"
              depressed
              @click="onEditAddressCancel"
            >
              ยกเลิก
            </v-btn>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,

      currentStep: 1,

      basicInfo: {},

      mobilePhone_state: '',

      mobilePhone: '',

      cardType: 0,

      profilePicture: '',

      reason: 0,

      reasonAddition: '',

      reasonFiles: [],

      oldreasonFiles: [],

      dialog: {
        mobilePhone: false,

        addresss: false
      },

      info: [],

      cardTypeList: [],

      deletefile: [],

      addresss: '',

      addresss_state: '',

      firstTime: true
    }
  },

  computed: {
    title() {
      return 'ขอทำบัตรประจำตัวพนักงาน'
    },

    rules() {
      return {
        required: v => !!v || this.$t('rulesErrorMessage.required'),

        onlyDigit: v =>
          /^\d+$/.test(v) || this.$t('rulesErrorMessage.onlyDigit')
      }
    },

    reasonList() {
      return [
        {
          text: 'ขอมีบัตรครั้งแรก',

          condition:
            '(สำหรับประเภทบัตรพนักงานมหาวิทยาลัยชั่วคราว กรุณาแนบไฟล์คำสั่งจ้างหรือสัญญาจ้าง)',

          value: 1,

          disabled: !this.firstTime
        },

        {
          text: 'บัตรเดิมหมดอายุ',

          condition: ' (แนบรูปบัตรเดิม)',

          value: 2
        },

        {
          text: 'บัตรหาย',

          condition: ' (แนบเอกสารเพิ่มเติม อย่างน้อย 1 ฉบับ)',

          value: 3
        },

        {
          text: 'เปลี่ยนข้อมูลในบัตร',

          condition: ' (เขียนข้อมูลที่ต้องทำการแก้ไขให้ชัดเจน)',

          value: 4
        },

        {
          text: 'บัตรชำรุด',

          condition: ' (แนบรูปบัตรเดิม)',

          value: 5
        },

        {
          text: 'อื่นๆ',

          condition: ' (กรุณาระบุเหตุผลเพิ่มเติม)',

          value: 6
        }
      ]
    },

    validateStep1() {
      return !!this.mobilePhone && !!this.addresss
    },

    validateStep2() {
      return this.cardType > 0
    },

    validateStep3() {
      return this.profilePicture !== ''
    },

    validateStep4() {
      let result = false

      if (this.reason > 0) {
        if (this.reason === 2 || this.reason === 3 || this.reason === 5) {
          if (this.reasonFiles.length > 0 || this.oldreasonFiles.length > 0) {
            result = true
          } else {
            result = false
          }
        } else if (this.reason === 6 || this.reason === 4) {
          if (this.reasonAddition) {
            result = true
          } else {
            result = false
          }
        } else {
          result = true
        }
      }

      return result
    },

    isEdit() {
      return this.$route.query.isEdit
    }
  },

  watch: {
    '$root.$i18n.locale'() {
      this.initialInfo()
    },

    $route() {
      if (this.$route.query.cardcode === undefined) {
        this.resetData()
      } else {
        this.initialInfo()
      }
    }
  },

  async mounted() {
    await this.initialInfo()
  },

  methods: {
    onSelectProfilePicture() {
      if (event.target.files.length > 0) {
        const filename = event.target.files[0].name.split('.')

        const fileExt = filename[filename.length - 1].toLowerCase()

        const accepted = ['jpg', 'jpeg', 'png']

        if (accepted.includes(fileExt)) {
          const canvas = document.createElement('canvas')

          const ctx = canvas.getContext('2d')

          const max = 960

          // resize

          const img = new Image()

          img.onload = () => {
            const iw = img.width

            const ih = img.height

            let scale = max / ih

            if (scale > 1) {
              scale = 1
            }

            const iwScaled = iw * scale

            const ihScaled = ih * scale

            canvas.width = iwScaled

            canvas.height = ihScaled

            ctx.drawImage(img, 0, 0, iwScaled, ihScaled)

            this.profilePicture = canvas.toDataURL('image/jpeg', 1)
          }

          img.src = URL.createObjectURL(event.target.files[0])
        } else {
          alert(this.$t('alertErrorMessage.noAcceptFileType'))

          this.profilePicture = ''
        }
      } else {
        this.profilePicture = ''
      }
    },

    onAddAttached(e) {
      const filename = e.target.files[0].name.split('.')

      const fileExt = filename[filename.length - 1].toLowerCase()

      const accepted = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx']

      if (accepted.includes(fileExt)) {
        this.reasonFiles.push(e.target.files[0])
      } else {
        alert(this.$t('alertErrorMessage.noAcceptFileType'))
      }

      // console.log(this.reasonFiles)
    },

    onEdit(id) {
      this.dialog[id] = true

      this.mobilePhone_state = this.mobilePhone

      this.addresss_state = this.addresss
    },

    onEditMobilePhoneSubmit() {
      if (this.$refs.editMobilePhoneForm.validate()) {
        this.info.map(item => {
          if (item.id === 'mobilePhone') {
            item.value = this.mobilePhone
          }

          return item
        })

        this.dialog.mobilePhone = false
      }
    },

    onEditAddressSubmit() {
      if (this.$refs.editAddressForm.validate()) {
        this.info.map(item => {
          if (item.id === 'addresss') {
            item.value = this.addresss
          }

          return item
        })

        this.dialog.addresss = false
      }
    },

    getReasonValue(text) {
      switch (text) {
        case this.reasonList[0].text:
          return this.reasonList[0].value

        case this.reasonList[1].text:
          return this.reasonList[1].value

        case this.reasonList[2].text:
          return this.reasonList[2].value

        case this.reasonList[3].text:
          return this.reasonList[3].value

        case this.reasonList[4].text:
          return this.reasonList[4].value

        case this.reasonList[5].text:
          return this.reasonList[5].value
      }

      return 0
    },

    onEditMobilePhoneCancel() {
      this.dialog.mobilePhone = false

      this.mobilePhone = this.mobilePhone_state
    },

    onEditAddressCancel() {
      this.dialog.addresss = false

      this.addresss = this.addresss_state
    },

    onReasonFileRemove(index) {
      this.reasonFiles.splice(index, 1)
    },

    onOldReasonFileRemove(index) {
      this.deletefile.push(this.oldreasonFiles[index].reqCardDocName)

      this.oldreasonFiles.splice(index, 1)
    },

    handlerFirstTime(temp) {
      this.firstTime = temp
    },

    validateForm() {
      return (
        this.validateStep1 &&
        this.validateStep2 &&
        this.validateStep3 &&
        this.validateStep4
      )
    },

    async resetData() {
      this.mobilePhone = ''

      this.cardType = 0

      this.profilePicture = ''

      this.reason = []

      this.reasonAddition = ''

      this.oldreasonFiles = []

      this.currentStep = 1

      this.initialInfo()
    },

    async onSubmit() {
      if (this.validateForm()) {
        this.loading = true

        try {
          if (this.isEdit) {
            const cardTypeInfo = this.cardTypeList.find(
              item => item.value === this.cardType
            )

            const reasonInfo = this.reasonList.find(
              item => item.value === this.reason
            )

            let dataCard = {}

            dataCard.ReqCardCode = this.$route.query.cardcode || ''

            dataCard.CardImgProflie = this.profilePicture || ''

            dataCard.MobilePhone = this.mobilePhone || ''

            dataCard.Addresss = this.addresss || ''

            dataCard.ReasonReqCard = reasonInfo.text

            if (
              this.reasonAddition &&
              reasonInfo.value !== 1 &&
              reasonInfo.value !== 2
            ) {
              dataCard.ReasonReqCard =
                dataCard.ReasonReqCard + ' - ' + this.reasonAddition
            }

            dataCard.CardTypeName = cardTypeInfo.cardTypeFullNameTha || ''

            dataCard.CardEmpTypeName = cardTypeInfo.cardEmpTypeFullNameTha || ''

            dataCard.CardTypeNameID = cardTypeInfo.cardTypeId || 0

            dataCard.CardEmpTypeNameID = cardTypeInfo.employeeTypeID || 0

            let formData = new FormData()

            formData.append('dataCard', JSON.stringify(dataCard))

            for (let index in this.reasonFiles) {
              let running_number = parseInt(index) + 1

              formData.append(
                'filename' + running_number,
                this.reasonFiles[index]
              )
            }

            formData.append('deletefile', JSON.stringify(this.deletefile))

            await this.$store.dispatch('reqCard/editRequest', formData)

            // console.log(res)

            this.$router.push(
              '/ReqCard/req/' + this.$route.query.cardcode + '/user'
            )

            // for (let pair of formData.entries()) {

            //   console.log(pair[0] + ', ' + pair[1])

            // }
          } else {
            const cardTypeInfo = this.cardTypeList.find(
              item => item.value === this.cardType
            )

            const reasonInfo = this.reasonList.find(
              item => item.value === this.reason
            )

            let dataCard = {}

            dataCard.EmployeeID = this.basicInfo.employeeID || ''

            dataCard.PrenameTha = this.basicInfo.prenameTha || ''

            dataCard.PrenameEng = this.basicInfo.prenameEng || ''

            dataCard.FirstNameTha = this.basicInfo.firstNameTha || ''

            dataCard.FirstNameEng = this.basicInfo.firstNameEng || ''

            dataCard.MiddleNameTha = this.basicInfo.middleNameTha || ''

            dataCard.MiddleNameEng = this.basicInfo.middleNameEng || ''

            dataCard.LastNameTha = this.basicInfo.lastNameTha || ''

            dataCard.LastNameEng = this.basicInfo.lastNameEng || ''

            dataCard.BirthDate =
              this.$dateFormat(this.basicInfo.birthDate, {
                format: 'YYYY-MM-DD'
              }) || ''

            dataCard.Age = this.basicInfo.age || ''

            dataCard.PersonalID = this.basicInfo.personalID || ''

            dataCard.BloodTypeID = this.basicInfo.bloodTypeID || ''

            dataCard.PositionNameTha = this.basicInfo.positionNameTha || ''

            dataCard.PositionNameEng = this.basicInfo.positionNameEng || ''

            dataCard.OrganizationFullNameTha =
              this.basicInfo.organizationFullNameTha || ''

            dataCard.OrganizationFullNameEng =
              this.basicInfo.organizationFullNameEng || ''

            dataCard.WorkLineName = this.basicInfo.workLineName || ''

            dataCard.PositionExecNameTha =
              this.basicInfo.positionExecNameTha || ''

            dataCard.PositionExecNameEng =
              this.basicInfo.positionExecNameEng || ''

            dataCard.OrganizationExecBudgetNameTha =
              this.basicInfo.organizationExecBudgetNameTha || ''

            dataCard.OrganizationExecBudgetNameEng =
              this.basicInfo.organizationExecBudgetNameEng || ''

            dataCard.EmailCMU = this.basicInfo.emailCMU || ''

            dataCard.NationalityNameTha =
              this.basicInfo.nationalityNameTha || ''

            dataCard.NationalityNameEng =
              this.basicInfo.nationalityNameEng || ''

            dataCard.Race = this.basicInfo.race || ''

            dataCard.HrPositionNumber = this.basicInfo.hrPositionNumber || ''

            dataCard.Addresss = this.addresss || ''

            dataCard.MobilePhone = this.mobilePhone || ''

            dataCard.CardImgProflie = this.profilePicture || ''

            dataCard.GetCardEmpTypeID = cardTypeInfo.employeeTypeID || ''

            dataCard.GetCardTypeID = cardTypeInfo.cardTypeId || ''

            dataCard.GetCardTypeFullNameTha =
              cardTypeInfo.cardTypeFullNameTha || ''

            dataCard.GetCardTypeFullNameEng =
              cardTypeInfo.cardTypeFullNameEng || ''

            dataCard.GetCardEmpTypeFullNameTha =
              cardTypeInfo.cardEmpTypeFullNameTha || ''

            dataCard.GetCardEmpTypeFullNameEng =
              cardTypeInfo.cardEmpTypeFullNameEng || ''

            dataCard.ReasonReqCard = reasonInfo.text

            if (
              this.reasonAddition &&
              reasonInfo.value !== 1 &&
              reasonInfo.value !== 2
            ) {
              dataCard.ReasonReqCard =
                dataCard.ReasonReqCard + ' - ' + this.reasonAddition
            }

            let formData = new FormData()

            formData.append('dataCard', JSON.stringify(dataCard))

            for (let index in this.reasonFiles) {
              let running_number = parseInt(index) + 1

              formData.append(
                'filename' + running_number,
                this.reasonFiles[index]
              )
            }

            // for (let pair of formData.entries()) {mobile

            //   console.log(pair[0] + ', ' + pair[1])

            // }

            const res = await this.$store.dispatch(
              'reqCard/addNewRequest',
              formData
            )

            this.$router.push('/ReqCard/req/' + res.data.data + '/user')
          }
        } catch (e) {
          console.log(e.response || e)
        }

        this.loading = false
      } else {
        if (!this.validateStep1) {
          this.currentStep = 1
        } else if (!this.validateStep2) {
          this.currentStep = 2
        } else if (!this.validateStep3) {
          this.currentStep = 3
        } else {
          this.currentStep = 4
        }
      }
    },

    async initialInfo() {
      const res = await this.apiGetInfo()

      const info = res.data?.data?.basicInfo[0] || {}

      const lang = this.$lang

      this.basicInfo = info

      this.mobilePhone = this.mobilePhone ? this.mobilePhone : info.mobilePhone

      this.addresss = this.addresss ? this.addresss : info.addresss

      this.info = [
        {
          id: 'firstName',

          title: 'ชื่อ',

          value: info[`firstName${lang}`]
            ? info[`firstName${lang}`]
            : this.$t('noData'),

          icon: 'mdi-file-document-multiple'
        },

        {
          id: 'lastName',

          title: 'นามสกุล',

          value: info[`lastName${lang}`]
            ? info[`lastName${lang}`]
            : this.$t('noData'),

          icon: 'mdi-file-document-multiple'
        },

        {
          id: 'birthDate',

          title: 'วันเกิด',

          value:
            lang === 'Tha'
              ? this.$dateFormatByLang(info.birthDate, {
                  format: 'DD MMMM YYYY',

                  addValue: 543
                })
              : this.$dateFormat(info.birthDate, {
                  format: 'DD MMMM YYYY',

                  locale: 'en'
                }),

          icon: 'mdi-cake'
        },

        {
          id: 'personalID',

          title: 'เลขบัตรประจำตัวประชาชน',

          value: info.personalID,

          icon: 'mdi-card-account-details',

          limit: 13
        },

        {
          id: 'employeeTypeName',

          title: 'ประเภทบุคลากร',

          value: info[`employeeTypeName${lang}`]
            ? info[`employeeTypeName${lang}`]
            : this.$t('noData'),

          icon: 'mdi-account-outline'
        },

        {
          id: 'positionName',

          title: 'ตำแหน่ง',

          value: info[`positionName${lang}`]
            ? info[`positionName${lang}`]
            : this.$t('noData'),

          icon: 'mdi-account-circle'
        },

        {
          id: 'emailCMU',

          title: 'อีเมล',

          value: info.emailCMU,

          icon: 'mdi-at'
        },

        {
          id: 'bloodTypeID',

          title: 'กรุ๊ปเลือด',

          value: info.bloodTypeID ? info.bloodTypeID : this.$t('noData'),

          icon: 'mdi-at'
        },

        {
          id: 'addresss',

          title: 'ที่อยู่',

          value: info.addresss,

          edit: true,

          icon: 'mdi-at'
        },

        {
          id: 'mobilePhone',

          title: 'หมายเลขโทรศัพท์',

          value: this.mobilePhone ? this.mobilePhone : info.mobilePhone,

          icon: 'mdi-phone',

          edit: true,

          limit: 10
        }
      ]

      if (this.info[this.info.length - 1].value === 'ไม่ประสงค์แจ้ง') {
        this.info[this.info.length - 1].value = ''

        this.mobilePhone = ''
      }

      if (info[`middleName${lang}`]) {
        this.info.splice(1, 0, {
          id: 'middleName',

          title: 'ชื่อกลาง',

          value: info[`middleName${lang}`]
            ? info[`middleName${lang}`]
            : this.$t('noData'),

          icon: 'mdi-file-document-multiple'
        })
      }

      this.cardTypeList = info.typeCard.map(item => {
        item.text = item[`cardTypeFullName${lang}`]
          ? item[`cardTypeFullName${lang}`]
          : item.cardTypeFullNameTha

        item.value = item.cardTypeId

        return item
      })

      // console.log(this.cardTypeList)

      if (this.isEdit) {
        const cardres = await this.apiGetCardInfo()

        const cardinfo = cardres.data.data || {}

        this.info.map(item => {
          if (item.id === 'mobilePhone') {
            item.value = cardinfo.mobilePhone
          }

          return item
        })

        this.info.map(item => {
          if (item.id === 'addresss') {
            item.value = cardinfo.addresss
          }

          return item
        })

        this.mobilePhone = cardinfo.mobilePhone

        this.addresss = cardinfo.addresss

        this.cardType = cardinfo.cardTypeID

        this.profilePicture = cardinfo.reqCardImg

        let index = cardinfo.reasonReqCard.indexOf(' - ')

        this.reason = this.getReasonValue(
          index === -1
            ? cardinfo.reasonReqCard
            : cardinfo.reasonReqCard.substr(0, index)
        )

        this.reasonAddition =
          index === -1 ? '' : cardinfo.reasonReqCard.substr(index + 3)

        this.oldreasonFiles = cardinfo.reqCardDocuments

        // console.log(cardres)

        // const cardinfo = res.data?.data?.basicInfo[0] || {}
      }
    },

    async apiGetInfo() {
      try {
        const res = await this.$store.dispatch('reqCard/getInfo')

        return res
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiGetCardInfo() {
      try {
        const res = await this.$store.dispatch(
          'reqCard/getInfoByCardcode',
          this.$route.query.cardcode
        )

        return res
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
